export function createMeter(
  parent,
  majorAmount,
  displayWidth,
  formatValue,
  initialValue,
  direction
) {
  var g = parent.append("g");

  // setup
  const majorHeight = 10;
  const majorSpacing = 70;
  const halfMajorHeight = (majorHeight * 2) / 3;
  const minorHeight = majorHeight / 3;
  const textSpacing = 2;
  const fmtMajor = formatValue;

  // current value
  let current = initialValue;

  // derived values
  const amountToPixels = majorSpacing / majorAmount;
  const pixelsToAmount = majorAmount / majorSpacing;
  const amountWidth = displayWidth * pixelsToAmount;

  g.append("line")
    .attr("x1", displayWidth * -0.5)
    .attr("y1", 0)
    .attr("x2", displayWidth * 0.5)
    .attr("y2", 0)
    .attr("stroke", "black");

  const ticks = {};
  let updateNumber = 0;

  function updateElements() {
    updateNumber++;

    const leftValue = current - amountWidth / 2;
    const rightValue = current + amountWidth / 2;
    const leftPixel = displayWidth * -0.5;
    const rightPixel = displayWidth * 0.5;
    const leftMajors = Math.floor(leftValue / majorAmount);
    const rightMajors = Math.floor(rightValue / majorAmount);

    for (let majors = leftMajors - 1; majors <= rightMajors + 1; majors++) {
      for (let minors = 0; minors < 10; minors++) {
        const value = (majors + minors / 10) * majorAmount;
        if (value < leftValue || value > rightValue) continue;

        const pos = leftPixel + (value - leftValue) * amountToPixels;

        let height;

        const key = majors * 10 + minors;
        const tick = key in ticks ? ticks[key] : (ticks[key] = {});

        tick.update = updateNumber;

        switch (minors) {
          case 0: // major
            height = majorHeight;

            if (!tick.text) {
              tick.text = g
                .append("text")
                .attr("y", (height + textSpacing) * direction)
                .attr("dominant-baseline", direction > 0 ? "hanging" : "auto")
                .attr("text-anchor", "middle")
                .attr("font-size", "12px")
                .attr("fill", "black")
                .text(fmtMajor(value));
            }

            tick.text.attr("x", pos);

            break;
          case 5: // half-major
            height = halfMajorHeight;
            break;
          default:
            // minor
            height = minorHeight;
            break;
        }

        if (!tick.line) {
          tick.line = g
            .append("line")
            .attr("y1", 0)
            .attr("y2", height * direction)
            .attr("stroke", "black");
        }

        tick.line.attr("x1", pos).attr("x2", pos);
      }
    }

    // remove unused ticks
    for (let key in ticks) {
      const tick = ticks[key];
      if (tick.update != updateNumber) {
        tick.line.remove();
        tick.text && tick.text.remove();
        delete ticks[key];
      }
    }
  }

  updateElements();

  return {
    setValue: (v) => {
      current = v;
      updateElements();
    },
  };
}
